import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-missed-prayers',
  templateUrl: './missed-prayers.component.html',
  styleUrls: ['./missed-prayers.component.scss'],
      encapsulation: ViewEncapsulation.None
})
export class MissedPrayersComponent implements OnInit {
  public arrCoupons: any[] = [];
   public lang : any

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
            private language : LanguageService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {

        this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});

    this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
  }
 


  getLevels() {
    this.apisService.users().subscribe({
      next: (response) => {
        this.levels = response.data;
        console.log(this.levels);
      },
    });
  }

 

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }
}
